import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Transaction } from "../types/transactions";
import { BASE_URL, envConfig } from "../config";
import { Invoice } from "../types/invoices";

// Define a service using a base URL and expected endpoints
export const invoicesApi = createApi({
  reducerPath: "invoicesApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "invoices",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["Invoices"],
  endpoints: (builder) => ({
    getInvoicess: builder.query<Invoice[], string>({
      query: () => `/`,
      providesTags: ["Invoices"],
    }),
    updateInvoicess: builder.mutation<Invoice, Invoice>({
      query: ({ _id, ...patch }) => ({
        url: `/${_id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["Invoices"],
    }),
    deleteInvoicess: builder.mutation<
      { success: boolean; _id: string },
      string
    >({
      query: (_id) => ({
        url: `/${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invoices"],
    }),
    createInvoicess: builder.mutation<Invoice, Invoice>({
      query: ({ _id, ...transaction }) => ({
        url: `/`,
        method: "POST",
        body: transaction,
      }),
      invalidatesTags: ["Invoices"],
    }),
    getInvoicessCalculation: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/calculations`,
        method: "POST",
        body: filter,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetInvoicessQuery,
  useCreateInvoicessMutation,
  useUpdateInvoicessMutation,
  useDeleteInvoicessMutation,
} = invoicesApi;
